import { type SimpleSelectOption } from '@workwave-tidal/core/components'
import { useMemo } from 'react'
import { useTexts } from './useTexts'

export function useOptions() {
  const texts = useTexts()

  return useMemo<SimpleSelectOption<string>[]>(() => {
    return optionsId.map(value => {
      switch (value) {
        case 'NO_REPEAT':
          return { value, label: texts.noRepeat }
        case 'DAILY':
          return { value, label: texts.daily }
        case 'WEEKLY':
          return { value, label: texts.weekly }
        case 'MONTHLY':
          return { value, label: texts.monthly }
        case 'ANNUALLY':
          return { value, label: texts.annually }
      }
    })
  }, [texts])
}

const optionsId = ['NO_REPEAT', 'DAILY', 'WEEKLY', 'MONTHLY', 'ANNUALLY'] as const
